// 德语
import de from '../JsonLang/de.json'
import enSpec from '../JsonLangSpec/en.json'
export const lang = {
  ...de, ...enSpec
}
